import React from 'react';
import { isNewUIEnabled } from 'hooks/useNewUI';
import AddSubCategoryModalNew from './AddSubCategoryModalNew';
import AddSubCategoryModalClassic from './AddSubCategoryModalClassic';

// The create-subcategory modal restyle ships only to allow-listed new-UI users.
// Classic (production) users keep the legacy modal.
const AddSubCategoryModal = (props) => (isNewUIEnabled()
  ? <AddSubCategoryModalNew {...props} />
  : <AddSubCategoryModalClassic {...props} />);

export default AddSubCategoryModal;
